/**
 * NOTE: If you edit this file, you may need to run writeElevYAML.js to see your changes
 * on 11ty pages.
 */

// "site-maintenance", "custom", or "" for no infobars
const DEFAULT_INFO_BAR_TYPE = "custom";

/**
 * Full list of infobars that *can* be shown on our pages. Note that everything is hidden
 * by default, JS will look for a matching infotype value for the infobar to show.
 *
 * Supported attributes:
 *  - REQUIRED: {String} infotype - type of infobar, used to determine which infobar(s) to show
 *  - REQUIRED: {String} text - primary text to render in infobar - supports inner HTML elements
 *  - REQUIRED: {String} cookie - must be unique, used to remember that a user has X'd out of an infobar
 *  - OPTIONAL: {Array} classes - of strings, class names to attach to the highest-level infobar element
 *  - OPTIONAL: {String} buttonText - button text to render if we want a corresponding button - doesn't
 *                                    currently support inner HTML elements
 *  - OPTIONAL: {String} buttonTextMobile - mobile version of button text (shows at ≤500px)
 *  - OPTIONAL: {String} buttonLink - link for a corresponding button - REQUIRED if buttonText is set
 *  - OPTIONAL: {Boolean} buttonNewTab - whether the button should open the page in a new tab
 */
const INFOBARS = [
	{
		infotype: "custom",
		text: `Want a live instructor for your <span class="infobar-hide-tinier">Beast Academy</span> student?`,
		classes: ["blue"],
		buttonText: "Enroll Now",
		buttonLink: "/live-classes",
		buttonNewTab: true,
		cookie: "live-instructor",
	},
	{
		infotype: "ipl-migration",
		text: `School accounts are moving to beastclassroom.com June 25–26. <a href="/assets/documents/ipl/beast-classroom-newsletter.pdf" target="_blank" rel="noopener noreferrer">View our <u>Newsletter</u></a> for more information.`,
		cookie: "school-migration-jun25",
		startDate: "2026-06-18",
		endDate: "2026-06-27", // day after migration ends
		classes: ["blue"],
	},
	{
		infotype: "primary-registration-reminder",
		text: "Don't forget to complete your child's account setup!",
		classes: ["blue"],
		buttonText: "Go to account setup",
		buttonTextMobile: "Set Up",
		buttonLink: "/parent/students/setup",
		cookie: "primary-registration-reminder",
		neverHide: true,
	},
	/* We use this B2B banner a lot so don't delete it. Only change the text,
	the cookie, and the start & end dates. */
	{
		text: "Meet the Beast Academy Team at ASCD from 3/22-3/25",
		cookie: "ascd24-conf-banner",
		startDate: "2024-03-22",
		endDate: "2024-03-26", // Needs to be the day after you want it to end b/c of the way Date()s work
		infotype: "custom",
		classes: ["blue", "b2b-conference-banner"],
		isForEducators: true,
	},
];

/**
 * Retrieves the list of infobars, with some (optional) options applied.
 *
 * @param {Object} opts
 *	- classNameMap: Map of old class names to new class names
 *		- Note that this is a super basic text find-and-replace, so elements with multiple class
 *			names aren't currently supported. If/when we need to support multiple class names, we
 *			could probably use capture groups, but that's more complexity than we need currently.
 *	- infotype: Filter by this infotype
 */
const getInfobars = ({classNameMap = {}, infotype} = {}) =>
	INFOBARS
		// NOTE: no filtering if infotype is falsy
		.filter(infobar => (infotype ? infobar.infotype === infotype : true))
		.map(infobar => {
			Object.entries(classNameMap).forEach(([oldName, newName]) => {
				const oldClassRegex = RegExp(`class=["']${oldName}["']`, "g");
				const newClassName = `class="${newName}"`;
				infobar.text = infobar.text.replace(oldClassRegex, newClassName);
				if (infobar.buttonText) {
					infobar.buttonText = infobar.buttonText.replace(
						oldClassRegex,
						newClassName
					);
				}
				if (infobar.classes) {
					const oldIndex = infobar.classes.indexOf(oldName);
					if (oldIndex >= 0) {
						infobar.classes.splice(oldIndex, 1, newName);
					}
				}
			});
			return infobar;
		});

module.exports = {
	getInfobars,
	DEFAULT_INFO_BAR_TYPE,
	INFOBARS,
};
